'use client';

import { useState } from 'react';
import { EditModal } from '@/components/ui/edit-modal';
import { PricingCalculatorField } from '@/features/tournament-wizard/blocks';
import type { Price, PaymentType, Tournament } from '@/types';

interface EditPriceModalProps {
  isOpen: boolean;
  onClose: () => void;
  tournament: Tournament;
  currentPrice: Price;
  currentPaymentType: PaymentType;
  onSave: (priceData: {
    price: Price;
    paymentType: PaymentType;
  }) => Promise<boolean>;
  isLoading: boolean;
}

export function EditPriceModal({
  isOpen,
  onClose,
  tournament,
  currentPrice,
  currentPaymentType,
  onSave,
  isLoading,
}: EditPriceModalProps) {
  void tournament;

  const [price, setPrice] = useState<Price>(currentPrice);
  const [paymentType, setPaymentType] =
    useState<PaymentType>(currentPaymentType);
  const [isPriceValid, setIsPriceValid] = useState(true);

  const handleSave = async () => {
    await onSave({ price, paymentType });
  };

  return (
    <EditModal
      isOpen={isOpen}
      onClose={onClose}
      title="Editar Precio y Método de Pago"
      onSave={handleSave}
      isLoading={isLoading}
      disabled={!isPriceValid}
      size="large"
    >
      <div className="max-h-[70vh] overflow-y-auto py-4">
        <PricingCalculatorField
          price={price}
          onPriceChange={setPrice}
          paymentType={paymentType}
          onPaymentTypeChange={setPaymentType}
          onPriceValidationChange={setIsPriceValid}
          config={{ isBalanceRestricted: false, showFeeBreakdown: true }}
          wrapInCard={false}
        />
      </div>
    </EditModal>
  );
}
